import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isHidden"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { Suspense } from 'react';
import { getContentTypeConfig, setContentTypeConfig } from './config';
import customContentTypes from './ContentTypes/customContentTypes';
/**
 *  add custom content types
 */

var addCustomContentTypes = function addCustomContentTypes(contentTypes) {
  var _iterator = _createForOfIteratorHelper(contentTypes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var ContentType = _step.value;
      var component = ContentType.component,
          configAggregator = ContentType.configAggregator;

      if (!ContentType.name) {
        ContentType.name = component.name;
      }

      if (ContentType.name && component && configAggregator) {
        setContentTypeConfig(ContentType.name, {
          component: component,
          configAggregator: configAggregator
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

addCustomContentTypes(customContentTypes);
/**
 * Render a content type
 *
 * @param Component
 * @param data
 * @returns {*}
 */

var renderContentType = function renderContentType(Component, data) {
  return React.createElement(Component, data, data.children.map(function (childTreeItem, i) {
    return React.createElement(ContentTypeFactory, {
      key: i,
      data: childTreeItem
    });
  }));
};
/**
 * Create an instance of a content type component based on configuration
 *
 * @param data
 * @returns {*}
 * @constructor
 */


var ContentTypeFactory = function ContentTypeFactory(_ref) {
  var data = _ref.data;

  var isHidden = data.isHidden,
      props = _objectWithoutProperties(data, _excluded);

  if (isHidden) {
    return null;
  }

  var contentTypeConfig = getContentTypeConfig(props.contentType);

  if (contentTypeConfig && contentTypeConfig.component) {
    var Component = renderContentType(contentTypeConfig.component, props);
    var ComponentShimmer = contentTypeConfig.componentShimmer ? renderContentType(contentTypeConfig.componentShimmer, props) : '';
    return React.createElement(Suspense, {
      fallback: ComponentShimmer
    }, Component);
  }

  return null;
};

export default ContentTypeFactory;